<div>
  <span class="period-Type">Period Type</span>
  <div>
    <nz-radio-group
      [(ngModel)]="periodValue"
      (ngModelChange)="onChangePeriod()"
      *ngFor="let item of periods"
    >
      <label nz-radio [nzValue]="item.type" class="radio-btn">{{
        item.typeHeader
      }}</label>
    </nz-radio-group>
  </div>

  <div class="period-div">
    <div class="relative-to-current">
      Relative to current period:
    </div>
    <div class="selected-period">
      <nz-select
        [(ngModel)]="selectedPeriod"
        (ngModelChange)="onSelectPeriod($event)"
        nzDropdownClassName="lim-period-menu"
      >
        <nz-option
          *ngFor="let data of relativeToCurrentPeriodList"
          [nzValue]="data"
          [nzLabel]="data"
        ></nz-option>
      </nz-select>
      <nz-divider class="period-divider"></nz-divider>
    </div>
  </div>
  <div class="edit-period-btn">
    <button nz-button (click)="closeEditPeriodPopUp()" class="cancel-btn">
      Cancel
    </button>
    <button
      nz-button
      nzType="primary"
      class="edit-period-apply-btn"
      (click)="applyPeriodSelections()"
    >
      Apply
    </button>
  </div>
</div>
